import { faCheck, faX } from '@fortawesome/pro-regular-svg-icons';

import { CARD_TYPES, GUEST_REASONS, PAYMENT_METHODS } from 'src/features/cards/types/card';
import { cardMessages } from 'src/features/cards/utils/messages';
import { PAYSTATION_STATES, PAYSTATION_TYPE_LOG } from 'src/features/payStations/types';
import payStationsMessages from 'src/features/payStations/utils/messages';
import { type BadgeOptions } from 'src/types/ui';

const badgeCardTypeOptions: BadgeOptions = {
    [CARD_TYPES.NORMAL]: {
        theme: 'green',
        label: cardMessages.cardTypeNormal,
    },
    [CARD_TYPES.MEMBERSHIP]: {
        theme: 'blue',
        label: cardMessages.cardTypeMembership,
    },
    [CARD_TYPES.SERVICE]: {
        theme: 'gray',
        label: cardMessages.cardTypeService,
    },
    [CARD_TYPES.VIP]: {
        theme: 'red',
        label: cardMessages.cardTypeVip,
    },
    [CARD_TYPES.OPERATOR]: {
        theme: 'primary',
        label: cardMessages.cardTypeOperator,
    },
    [CARD_TYPES.PREPAID]: {
        theme: 'purple',
        label: cardMessages.cardTypePrepaid,
    },
    [CARD_TYPES.PREPAID_S]: {
        theme: 'fuchsia',
        label: cardMessages.cardTypePrepaidS,
    },
    [CARD_TYPES.UNKNOWN]: {
        theme: 'gray',
        label: cardMessages.unknownCardType,
    },
};

const badgeCardTypeFilterOptions: BadgeOptions = {
    [CARD_TYPES.NORMAL]: {
        theme: 'green',
        label: cardMessages.cardTypeNormal,
    },

    [CARD_TYPES.VIP]: {
        theme: 'red',
        label: cardMessages.cardTypeVip,
    },

    [CARD_TYPES.PREPAID]: {
        theme: 'purple',
        label: cardMessages.cardTypePrepaid,
    },
};

const badgePayStationStateOptions: BadgeOptions = {
    [PAYSTATION_STATES.OPERATION]: {
        theme: 'green',
        label: payStationsMessages.operational,
    },
    [PAYSTATION_STATES.WARNING]: {
        theme: 'yellow',
        label: payStationsMessages.warning,
    },
    [PAYSTATION_STATES.ERROR]: {
        theme: 'red',
        label: payStationsMessages.error,
    },
    [PAYSTATION_STATES.NO_CONNECTION]: {
        theme: 'orange',
        label: payStationsMessages.noConnection,
    },
};

const badgePayStationLogOptions: BadgeOptions = {
    [PAYSTATION_TYPE_LOG.INFO]: {
        theme: 'green',
        label: payStationsMessages.info,
    },
    [PAYSTATION_TYPE_LOG.WARNING]: {
        theme: 'yellow',
        label: payStationsMessages.warning,
    },
    [PAYSTATION_TYPE_LOG.ERROR]: {
        theme: 'red',
        label: payStationsMessages.error,
    },
};

const badgeResolvedBooleanOptions: BadgeOptions = {
    true: {
        icon: faCheck,
        theme: 'green',
        label: payStationsMessages.areResolved,
    },
    false: {
        icon: faX,
        theme: 'red',
        label: payStationsMessages.areNotResolved,
    },
};

const paymentMethodOptions = [
    { label: cardMessages.cash, value: PAYMENT_METHODS.cash },
    { label: cardMessages.card, value: PAYMENT_METHODS.card },
    { label: cardMessages.bank, value: PAYMENT_METHODS.bank },
];

const guestReasonOptions = [
    { label: cardMessages.ticketValidation, value: GUEST_REASONS.ticketValidation },
    { label: cardMessages.freeExit, value: GUEST_REASONS.exitOpen },
];

const allowedDays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'] as const;

export {
    badgePayStationLogOptions,
    badgePayStationStateOptions,
    badgeCardTypeOptions,
    badgeCardTypeFilterOptions,
    paymentMethodOptions,
    guestReasonOptions,
    allowedDays,
    badgeResolvedBooleanOptions,
};
